export const pinConstants = {
    PIN_SAVE_REQUEST: 'PIN_SAVE_REQUEST',
    PIN_SAVE_SUCCESS: 'PIN_SAVE_SUCCESS',
    PIN_SAVE_FAILURE: 'PIN_SAVE_FAILURE',
    PIN_SAVE_CLEAR: 'PIN_SAVE_CLEAR',
};